import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import type { SingleOption } from '@cpm-pr1618001/ng-design-lib';
import {
  CcdlButtonComponent,
  CcdlCardComponent,
  CcdlInputComponent,
  CcdlSingleSelectComponent,
  CcdlTextAreaComponent,
  ErrorConfig,
} from '@cpm-pr1618001/ng-design-lib';
import { Countries } from '@cpm-pr1618003/ng-initializer-lib';

@Component({
  selector: 'about-us-ui',
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss',
  imports: [
    CcdlButtonComponent,
    CcdlInputComponent,
    CcdlCardComponent,
    CcdlTextAreaComponent,
    CcdlSingleSelectComponent,
  ],
  standalone: true,
})
export class AboutUsComponent implements OnChanges {
  @Input() contactForm!: FormGroup;
  @Input() isSubmitTriggered: boolean = false;
  @Input() countries!: Countries[];
  @Output() contactFormClicked = new EventEmitter<void>();

  nameErrorConfig: ErrorConfig = {
    required: 'This field is required.',
    minlength: 'Name should be more than 3 characters.',
    pattern: 'Special characters are not allowed.',
  };

  emailErrorConfig: ErrorConfig = {
    required: 'Email address is required.',
    pattern: 'Please enter a valid email address.',
  };

  countryCodeErrorConfig: ErrorConfig = {
    required: 'Country code is required.',
  };

  helpErrorConfig: ErrorConfig = {
    required: 'Please describe how we can help you.',
    pattern: 'Special characters are not allowed.',
  };

  countryOptions: SingleOption[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.countries?.currentValue?.length > 0) {
      this.formatCountryOptions();
    }
  }

  getControl(controlName: string): FormControl {
    return this.contactForm.get(controlName) as FormControl;
  }

  onSubmitClick(): void {
    this.contactFormClicked.emit();
  }
  private formatCountryOptions(): void {
    this.countryOptions = this.countries.map((country: Countries) => ({
      label: country.countryName,
      value: country.countryCode,
    }));
  }
}
